import { useEffect, useState } from "react";
import { SOLAR } from "@/constants/testIds";
import MyLocationButton from "@/components/solar/MyLocationButton";
import { BTN_PRIMARY, ErrorText, Field, UNDERLINE_INPUT } from "@/components/solar/ui";

interface Props {
  lat: number;
  lon: number;
  onApply: (lat: number, lon: number) => void;
  onDeviceLocation: (lat: number, lon: number) => void;
}

const show = (n: number) => String(Number(n.toFixed(6)));

function validate(la: number, lo: number): string {
  if (Number.isNaN(la) || la < -90 || la > 90) return "Latitude must be a number between −90 and 90.";
  if (Number.isNaN(lo) || lo < -180 || lo > 180) return "Longitude must be a number between −180 and 180.";
  return "";
}

export default function CoordsForm({ lat, lon, onApply, onDeviceLocation }: Props) {
  const [latInput, setLatInput] = useState(show(lat));
  const [lonInput, setLonInput] = useState(show(lon));
  const [error, setError] = useState("");

  // Mirror location changes made elsewhere (e.g. "Use my location").
  useEffect(() => {
    setLatInput(show(lat));
    setLonInput(show(lon));
  }, [lat, lon]);

  const apply = () => {
    const la = parseFloat(latInput);
    const lo = parseFloat(lonInput);
    const problem = validate(la, lo);
    setError(problem);
    if (!problem) onApply(la, lo);
  };

  return (
    <>
      <div className="flex flex-col gap-6 md:flex-row md:items-end">
        <Field label="Latitude">
          <input data-testid={SOLAR.latInput} type="number" step="any" value={latInput} onChange={(e) => setLatInput(e.target.value)} className={UNDERLINE_INPUT} />
        </Field>
        <Field label="Longitude">
          <input data-testid={SOLAR.lonInput} type="number" step="any" value={lonInput} onChange={(e) => setLonInput(e.target.value)} className={UNDERLINE_INPUT} />
        </Field>
        <div className="flex gap-3">
          <button data-testid={SOLAR.applyCoordsBtn} onClick={apply} className={BTN_PRIMARY}>
            Apply
          </button>
          <MyLocationButton onLocation={onDeviceLocation} onError={setError} />
        </div>
      </div>
      <ErrorText message={error} />
    </>
  );
}
